import { API } from "aws-amplify";
import qs from 'qs';

async function getSiteVehicles(siteId: string, start: number, end: number, companyId?: string): Promise<Array<VehicleDetection>> {
  try {
    // const paths: string[] = [];

    // let current: number = Date.now();
    // const start: number = Date.now() - (2592000000 * 12);

    // while (current > start) {
    //   paths.push(`/vehicles?${qs.stringify({ siteId, asCompany: companyId, startTime: current - 2592000000, endTime: current })}`)
    //   current -= 2592000000;
    // }

    // const promises = await Promise.allSettled(paths.map(el => API.get('api-service', el, {})));

    // //@ts-ignore
    // const data = flattenDeep(promises.filter(el => el.status === "fulfilled").map(el => el.value.data));

    const data = await API.get(
      'api-service',
      `/vehicles?${qs.stringify({ siteId, asCompany: companyId, startTime: start, endTime: end })}`,
      {}
    )

    if (data) {
      return data?.data?.map((vehicleDetection: any) => ({
        ...vehicleDetection,
        eventTimestamp: new Date(vehicleDetection.eventTimestamp).getTime(),
        detectionTimestamp: new Date(vehicleDetection.detectionTimestamp).getTime(),
        plate: vehicleDetection.plate ? vehicleDetection.plate.toLowerCase() : null
      }));
    }

    return [];
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export default getSiteVehicles;
